import { useTranslation } from 'react-i18next';

export const useI18n = () => {
  const { i18n, t } = useTranslation();
  return { t, i18n };
};